import { FormItem, SelectInput } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent';
import { ITextWidget, TextWidgetKind } from './ITextWidget';

export const TextWidgetConfigSchema: yup.ObjectSchema<ITextWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Text).required(),
    kind: yup
      .string()
      .oneOfEnum(TextWidgetKind)
      .default(TextWidgetKind.Text)
      .required()
      .label('Tipo'),
  })
    .required()
    .noUnknown();

export interface ITextInputConfigComponentProps
  extends IWidgetComponentProps<ITextWidget> {}

export function TextInputConfigComponent(
  props: ITextInputConfigComponentProps,
) {
  return (
    <div>
      <FormItem name="kind" label="Tipo">
        <SelectInput
          name="kind"
          defaultValue={TextWidgetKind.Text}
          options={[
            {
              label: 'Campo di Testo',
              value: TextWidgetKind.Text,
            },
            {
              label: 'Area di Testo',
              value: TextWidgetKind.TextArea,
            },
          ]}
        />
      </FormItem>
      <CommonConfigComponent {...props} />
    </div>
  );
}
